import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, opacity = 0, strokeWidth }) => (
  <g
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m102 93.489c7.0024-6.6893 16.314-10.422 25.999-10.422 9.6835 0 18.995 3.7325 25.999 10.422" />
    <path d="m76.841 68.329c13.677-13.362 32.038-20.843 51.159-20.843 19.121 0 37.482 7.4809 51.158 20.843" />
    <path d="m127.99 118.79a0.0082275 0.048469 0 0 1 0.01-5e-5" />
    <path
      d="m148.55 174.6a62.925 62.925 0 0 1-41.325-0.075 6 6 0 0 1-3.9-4.425l-4.35-22.125a6.15 6.15 0 0 0-3.675-4.425l-35.475-14.175a5.925 5.925 0 0 0-6.975 1.875 36 36 0 0 0 3 47.475 102.08 102.08 0 0 0 144.3 0 36 36 0 0 0 3-47.475 5.925 5.925 0 0 0-6.975-1.875l-35.475 14.175a6.15 6.15 0 0 0-3.675 4.35l-4.65 22.275a5.925 5.925 0 0 1-3.825 4.425z"
      fill={opacity ? color : 'none'}
      fillOpacity={opacity}
      strokeWidth={opacity === 1 ? 0 : strokeWidth}
    />
  </g>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const VoWifi = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

VoWifi.displayName = 'VoWifi';
